'use client';
import { FullWidthImageProps } from './types';
import Media from 'components/shared/Media/Media';
import { cn, getColorway, getYMargins } from 'utils/styles';

const FullWidthImage = ({
  desktopImage,
  mobileImage,
  sectionName,
  renderAsFullBleed,
  color,
  margins,
}: FullWidthImageProps) => {
  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={cn(getColorway(color), getYMargins(margins))}
      data-testid="full-width-image">
      <div className={renderAsFullBleed ? '' : 'content-wrapper'}>
        <Media
          media={desktopImage}
          mobileMedia={mobileImage}
          sizes={'100vw'}
          className="w-full rounded-none object-none"
        />
      </div>
    </section>
  );
};

export default FullWidthImage;
